<template>
  <div class="query-page">
    <div class="page-inner">
      <el-form class="form step-content" :model="query" label-width="130px">
        <img class="banner" src="~@/assets/img/complex_query.png" alt="" />
        <div class="title">複合查詢</div>

        <!-- 基本搜尋 -->
        <div class="row">
          <div class="col">
            <el-form-item label="姓名">
              <el-input clearable maxlength="20" v-model="query.NameKeyword" />
            </el-form-item>
          </div>
          <div class="col">
            <el-form-item label="性別">
              <el-select class="w-100" clearable v-model="query.Sex">
                <el-option label="男" :value="0" />
                <el-option label="女" :value="1" />
              </el-select>
            </el-form-item>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <el-form-item label="國籍">
              <el-select
                class="w-100"
                value-key="Guid"
                multiple
                filterable
                v-model="query.Nationalities"
              >
                <el-option
                  v-for="country in countryOptions"
                  :key="country.Guid"
                  :label="country.Name"
                  :value="country.Name"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="col">
            <el-form-item label="後續聯絡">
              <el-select
                class="w-100"
                clearable
                multiple
                v-model="query.ResumeContactRemarks"
              >
                <el-option label="可再約" :value="0" />
                <el-option label="永不聯絡" :value="1" />
              </el-select>
            </el-form-item>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <el-form-item label="通訊地址縣市">
              <el-select
                class="w-100"
                multiple
                filterable
                value-key="Guid"
                v-model="query.ContactCounties"
              >
                <el-option
                  v-for="city in cityOptions"
                  :key="city.Guid"
                  :label="city.Name"
                  :value="city.Name"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="col">
            <el-form-item label="通訊地址區域">
              <el-select
                class="w-100"
                multiple
                filterable
                v-model="query.ContactDistricts"
              >
                <el-option
                  v-for="district in districtOptions"
                  :key="district.Name"
                  :label="district.Name"
                  :value="district.Name"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <el-form-item label="經驗分類">
              <el-select
                class="w-100"
                multiple
                filterable
                value-key="Guid"
                placeholder="請選擇"
                v-model="query.ResumeTags"
              >
                <el-option
                  v-for="resumeTag in resumeTagOptions"
                  :key="resumeTag.Guid"
                  :label="resumeTag.Name"
                  :value="resumeTag.Name"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="col">
            <el-form-item label="其他分類">
              <el-select
                class="w-100"
                multiple
                filterable
                value-key="Guid"
                placeholder="請選擇"
                v-model="query.ResumeFreeTags"
              >
                <el-option
                  v-for="freeTag in freeTagOptions"
                  :key="freeTag.Guid"
                  :label="freeTag.Name"
                  :value="freeTag.Name"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <el-form-item label="過往應徵職缺">
              <el-select
                style="width: 100%"
                v-model="query.ManpowerDemandNo"
                filterable
                clearable
                placeholder="請選擇"
              >
                <el-option
                  v-for="position in positionOptions"
                  :key="position.Value"
                  :label="position.Text"
                  :value="position.Value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>

        <!-- 學歷 -->
        <div class="category" :class="{ open: educationCollapse === true }">
          <div class="sp"><span>學歷</span></div>
          <div class="row">
            <div class="col">
              <el-form-item label="學校">
                <el-select
                  class="w-100"
                  multiple
                  filterable
                  allow-create
                  placeholder="請選擇"
                  v-model="query.Schools"
                >
                  <el-option
                    v-for="school in schoolOptions"
                    :key="school.Guid"
                    :label="school.Name"
                    :value="school.Name"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <el-form-item label="科系類別">
                <el-select
                  class="w-100"
                  multiple
                  filterable
                  placeholder="請選擇"
                  v-model="query.Majors"
                >
                  <el-option
                    v-for="major in majorOptions"
                    :key="major.Guid"
                    :label="major.Name"
                    :value="major.Name"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="col">
              <el-form-item label="科系">
                <el-input
                  clearable
                  maxlength="50"
                  v-model="query.MajorNameKeyword"
                />
              </el-form-item>
            </div>
          </div>
        </div>

        <div class="toggle-btn-wrap">
          <span @click="educationCollapse = !educationCollapse">
            {{ workExperienceCollapse ? "收合學歷選項" : "展開學歷選項" }}
            <eva-icon
              :name="
                educationCollapse
                  ? 'chevron-up-outline'
                  : 'chevron-right-outline'
              "
              fill="#222"
              width="15"
            />
          </span>
        </div>

        <!-- 工作經歷 -->
        <div
          class="category"
          :class="{ open: workExperienceCollapse === true }"
        >
          <div class="sp"><span>工作經歷</span></div>

          <div class="row">
            <div class="col">
              <el-form-item label="總年資起迄">
                <el-input-number
                  style="width: 165px"
                  size="medium"
                  :min="0"
                  :max="99.9"
                  :precision="1"
                  :step="0.1"
                  v-model="query.TotalSeniorityMin"
                />
                至
                <el-input-number
                  style="width: 165px"
                  size="medium"
                  :min="0"
                  :max="99.9"
                  :precision="1"
                  :step="0.1"
                  v-model="query.TotalSeniorityMax"
                />
              </el-form-item>
            </div>
            <div class="col">
              <el-form-item label="希望年薪起迄">
                <el-input-number
                  style="width: 165px"
                  size="medium"
                  :min="0"
                  :max="99999999"
                  v-model="query.ExpectedYearlySalaryMin"
                />
                至
                <el-input-number
                  style="width: 165px"
                  size="medium"
                  :min="0"
                  :max="99999999"
                  v-model="query.ExpectedYearlySalaryMax"
                />
              </el-form-item>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <el-form-item label="曾任職公司">
                <el-input
                  clearable
                  maxlength="50"
                  v-model="query.CompanyKeyword"
                />
              </el-form-item>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <el-form-item label="曾任職產業">
                <el-select
                  class="w-100"
                  multiple
                  v-model="query.IndustryCategories"
                >
                  <el-option label="電子產業" :value="0" />
                  <el-option label="封測產業" :value="1" />
                  <el-option label="傳統產業" :value="2" />
                  <el-option label="其他產業" :value="3" />
                </el-select>
              </el-form-item>
            </div>
            <div class="col">
              <el-form-item label="曾任職職務">
                <el-input
                  clearable
                  maxlength="50"
                  v-model="query.PositionKeyword"
                />
              </el-form-item>
            </div>
          </div>
        </div>

        <div class="toggle-btn-wrap">
          <span @click="workExperienceCollapse = !workExperienceCollapse">
            {{
              workExperienceCollapse ? "收合工作經歷選項" : "展開工作經歷選項"
            }}
            <eva-icon
              :name="
                workExperienceCollapse
                  ? 'chevron-up-outline'
                  : 'chevron-right-outline'
              "
              fill="#222"
              width="15"
            />
          </span>
        </div>

        <!-- 專業技能 -->
        <div class="category" :class="{ open: skillCollapse === true }">
          <div class="sp"><span>專業技能</span></div>

          <div class="row">
            <div class="col">
              <el-form-item label="專業技能">
                <el-input
                  clearable
                  maxlength="50"
                  v-model="query.SkillKeyword"
                />
              </el-form-item>
            </div>
            <div class="col">
              <el-form-item label="培訓紀錄">
                <el-input
                  clearable
                  maxlength="50"
                  v-model="query.TrainingRecordKeyword"
                />
              </el-form-item>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <el-form-item label="證照檢定">
                <el-input
                  clearable
                  maxlength="50"
                  v-model="query.CertificateKeyword"
                />
              </el-form-item>
            </div>
            <div class="col">
              <el-form-item label="挫折忍耐度">
                <el-select
                  class="w-100"
                  multiple
                  v-model="query.FrustrationTolerances"
                >
                  <el-option label="高" :value="0" />
                  <el-option label="中" :value="1" />
                  <el-option label="低" :value="2" />
                </el-select>
              </el-form-item>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <el-form-item label="語言種類">
                <el-select
                  class="w-100"
                  multiple
                  filterable
                  allow-create
                  placeholder="請選擇"
                  v-model="query.Languages"
                >
                  <el-option
                    v-for="language in languageOptions"
                    :key="language.Guid"
                    :label="language.Name"
                    :value="language.Name"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="col">
              <el-form-item label="語言檢定">
                <el-input
                  clearable
                  maxlength="50"
                  v-model="query.LanguageTestKeyword"
                />
              </el-form-item>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <el-form-item label="語言程度(聽)">
                <el-select
                  class="w-100"
                  multiple
                  filterable
                  allow-create
                  placeholder="請選擇"
                  v-model="query.LanguageListenGuids"
                >
                  <el-option
                    v-for="degree in degreeOptions"
                    :key="degree.Guid"
                    :label="degree.Name"
                    :value="degree.Guid"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="col">
              <el-form-item label="語言程度(說)">
                <el-select
                  class="w-100"
                  multiple
                  filterable
                  allow-create
                  placeholder="請選擇"
                  v-model="query.LanguageSpeakGuids"
                >
                  <el-option
                    v-for="degree in degreeOptions"
                    :key="degree.Guid"
                    :label="degree.Name"
                    :value="degree.Guid"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <el-form-item label="語言程度(讀)">
                <el-select
                  class="w-100"
                  multiple
                  filterable
                  allow-create
                  placeholder="請選擇"
                  v-model="query.LanguageReadGuids"
                >
                  <el-option
                    v-for="degree in degreeOptions"
                    :key="degree.Guid"
                    :label="degree.Name"
                    :value="degree.Guid"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="col">
              <el-form-item label="語言程度(寫)">
                <el-select
                  class="w-100"
                  multiple
                  filterable
                  allow-create
                  placeholder="請選擇"
                  v-model="query.LanguageWriteGuids"
                >
                  <el-option
                    v-for="degree in degreeOptions"
                    :key="degree.Guid"
                    :label="degree.Name"
                    :value="degree.Guid"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
        </div>

        <div class="toggle-btn-wrap">
          <span @click="skillCollapse = !skillCollapse">
            {{ skillCollapse ? "收合專業技能選項" : "展開專業技能選項" }}
            <eva-icon
              :name="
                skillCollapse ? 'chevron-up-outline' : 'chevron-right-outline'
              "
              fill="#222"
              width="15"
            />
          </span>
        </div>

        <!-- 工作相關 -->
        <div
          class="category"
          :class="{ open: workCooperationCollapse === true }"
        >
          <div class="sp"><span>工作相關</span></div>
          <div class="row">
            <div class="col">
              <el-form-item label="配合日夜輪班">
                <div class="field">
                  <div class="field-radio">
                    <label>
                      <input
                        type="radio"
                        :value="true"
                        v-model="query.CanShiftWork"
                      />
                      <span>是</span>
                    </label>
                    <label>
                      <input
                        type="radio"
                        :value="false"
                        v-model="query.CanShiftWork"
                      />
                      <span>否</span>
                    </label>
                    <label>
                      <input
                        type="radio"
                        :value="null"
                        v-model="query.CanShiftWork"
                      />
                      <span>不拘</span>
                    </label>
                  </div>
                </div>
              </el-form-item>
            </div>
            <div class="col">
              <el-form-item label="配合「出差/派駐」">
                <el-select
                  class="w-100"
                  clearable
                  multiple
                  v-model="query.CanOfficeTripOrStations"
                >
                  <el-option label="否 No" :value="0" />
                  <el-option label="可接受1-3個月" :value="1" />
                  <el-option label="可接受半年" :value="2" />
                  <el-option label="可接受1年" :value="3" />
                  <el-option label="可接受2年以上" :value="4" />
                </el-select>
              </el-form-item>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <el-form-item label="影響工作配合">
                <div class="field">
                  <div class="field-radio">
                    <label>
                      <input
                        type="radio"
                        :value="true"
                        v-model="query.HasLackOfWorkCooperation"
                      />
                      <span>是</span>
                    </label>
                    <label>
                      <input
                        type="radio"
                        :value="false"
                        v-model="query.HasLackOfWorkCooperation"
                      />
                      <span>否</span>
                    </label>
                    <label>
                      <input
                        type="radio"
                        :value="null"
                        v-model="query.HasLackOfWorkCooperation"
                      />
                      <span>不拘</span>
                    </label>
                  </div>
                </div>
              </el-form-item>
            </div>
            <div class="col">
              <el-form-item label="有保密義務">
                <div class="field">
                  <div class="field-radio">
                    <label>
                      <input
                        type="radio"
                        :value="true"
                        v-model="query.HasNDA"
                      />
                      <span>是</span>
                    </label>
                    <label>
                      <input
                        type="radio"
                        :value="false"
                        v-model="query.HasNDA"
                      />
                      <span>否</span>
                    </label>
                    <label>
                      <input
                        type="radio"
                        :value="null"
                        v-model="query.HasNDA"
                      />
                      <span>不拘</span>
                    </label>
                  </div>
                </div>
              </el-form-item>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <el-form-item label="有禁止條款">
                <div class="field">
                  <div class="field-radio">
                    <label>
                      <input
                        type="radio"
                        :value="true"
                        v-model="query.HasNCC"
                      />
                      <span>是</span>
                    </label>
                    <label>
                      <input
                        type="radio"
                        :value="false"
                        v-model="query.HasNCC"
                      />
                      <span>否</span>
                    </label>
                    <label>
                      <input
                        type="radio"
                        :value="null"
                        v-model="query.HasNCC"
                      />
                      <span>不拘</span>
                    </label>
                  </div>
                </div>
              </el-form-item>
            </div>
            <div class="col">
              <el-form-item label="有智財">
                <div class="field">
                  <div class="field-radio">
                    <label>
                      <input type="radio" :value="true" v-model="query.HasIP" />
                      <span>是</span>
                    </label>
                    <label>
                      <input
                        type="radio"
                        :value="false"
                        v-model="query.HasIP"
                      />
                      <span>否</span>
                    </label>
                    <label>
                      <input type="radio" :value="null" v-model="query.HasIP" />
                      <span>不拘</span>
                    </label>
                  </div>
                </div>
              </el-form-item>
            </div>
          </div>
        </div>
        <div class="toggle-btn-wrap">
          <span @click="workCooperationCollapse = !workCooperationCollapse">
            {{
              workCooperationCollapse ? "收合工作相關選項" : "展開工作相關選項"
            }}
            <eva-icon
              :name="
                workCooperationCollapse
                  ? 'chevron-up-outline'
                  : 'chevron-right-outline'
              "
              fill="#222"
              width="15"
            />
          </span>
        </div>

        <!-- 履歷狀態 -->
        <div class="category" :class="{ open: resumeStatusCollapse === true }">
          <div class="sp"><span>履歷狀態相關</span></div>
          <div class="row">
            <div class="col">
              <el-form-item label="聯繫狀態">
                <el-cascader
                  class="w-100"
                  :options="contactOptions"
                  clearable
                  :props="cascaderProps"
                  :show-all-levels="false"
                  placeholder="請選擇"
                  v-model="query.ContactStatusGuids"
                />
              </el-form-item>
            </div>
            <div class="col">
              <el-form-item label="招募狀態">
                <el-select
                  class="w-100"
                  clearable
                  multiple
                  v-model="query.recruitStatus"
                >
                  <el-option label="尚未邀約" :value="0" />
                  <el-option label="待面談" :value="1" />
                  <el-option label="已面談" :value="2" />
                  <el-option label="面談未到" :value="3" />
                </el-select>
              </el-form-item>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <el-form-item label="面談結果">
                <el-select
                  class="w-100"
                  clearable
                  multiple
                  v-model="query.interviewResult"
                >
                  <el-option label="複試" :value="0" />
                  <el-option label="錄取" :value="1" />
                  <el-option label="考慮中" :value="2" />
                  <el-option label="不錄取" :value="3" />
                </el-select>
              </el-form-item>
            </div>
            <div class="col">
              <el-form-item label="任用結果">
                <el-select
                  class="w-100"
                  clearable
                  multiple
                  v-model="query.appointResult"
                >
                  <el-option label="簽核中" :value="0" />
                  <el-option label="Process Fail" :value="1" />
                  <el-option label="Offer Fail" :value="2" />
                  <el-option label="待報到" :value="3" />
                  <el-option label="已報到" :value="4" />
                  <el-option label="人力凍結" :value="5" />
                  <el-option label="單位 Reject" :value="6" />
                </el-select>
              </el-form-item>
            </div>
          </div>
        </div>
        <div class="toggle-btn-wrap">
          <span @click="resumeStatusCollapse = !resumeStatusCollapse">
            {{ resumeStatusCollapse ? "收合履歷狀態選項" : "展開履歷狀態選項" }}
            <eva-icon
              :name="
                resumeStatusCollapse
                  ? 'chevron-up-outline'
                  : 'chevron-right-outline'
              "
              fill="#222"
              width="15"
            />
          </span>
        </div>

        <div class="send-wrap">
          <el-button type="primary" @click="search">查詢</el-button>
          <el-button @click="query = {}">清除</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "ComplexQuery",

  data() {
    return {
      cascaderProps: { multiple: true },

      query: {
        CanShiftWork: null,
        HasLackOfWorkCooperation: null,
        HasNDA: null,
        HasNCC: null,
        HasIP: null,
      },
      districtOptions: [],
      degreeOptions: [],
      contactOptions: [],

      //是否展開學校選項
      educationCollapse: false,
      //是否展開工作經歷選項
      workExperienceCollapse: false,
      //是否展開專業技能選項
      skillCollapse: false,
      //是否展開工作相關選項
      workCooperationCollapse: false,
      //是否展開履歷狀態選項
      resumeStatusCollapse: false,
    };
  },

  methods: {
    // 複合查詢
    search() {
      this.updateLoading(true);
      this.query.ContactStatusGuids = this.query.ContactStatusGuids
        ? this.query.ContactStatusGuids.map((item) => {
            return item[1];
          })
        : null;
        console.log(this.query)
      localStorage.setItem("QUERY", JSON.stringify(this.query));
      localStorage.setItem("ORIGIN_PATH", this.$route.name.split(",")[1]);
      this.$router.push({ path: "/manager/talent/queryresult" });
    },

    async getData() {
      // 取得 國籍
      await this.$store.dispatch("GetCountry");
      // 取得 縣市
      await this.$store.dispatch("GetCity");
      // 取得 學校
      await this.$store.dispatch("GetSchool");
      // 取得 科系
      await this.$store.dispatch("GetMajor");
      // 取得 語言
      await this.$store.dispatch("GetLanguage");
      // 取得 履歷分類標簽
      await this.$store.dispatch("GetResumeTag");
      // 取得 其他分類標簽
      await this.$store.dispatch("GetFreeTag");
      // 取得 過往應徵職缺
      await this.$store.dispatch("GetPosition");
      // 取得 行政區包含縣市名
      const district = await this.$api.address.getDistrictFullName();
      this.districtOptions = district.data.map((item) => {
        return {
          Name: item.Name,
        };
      });
      // 取得 程度列表
      const degree = await this.$api.language.getLanguageDegree();
      this.degreeOptions = degree.data.map((item) => {
        return {
          Guid: item.Guid,
          Name: item.Name,
        };
      });
      // 取得 聯繫狀態
      const status = await this.$api.contactRecord.getContactStatusForQuery(false);
      this.contactOptions = status.data.map((item) => {
        return {
          value: item.Guid,
          label: item.Name,
          children: item.Children.map((children) => {
            return {
              value: children.Guid,
              label: children.Name,
            };
          }),
        };
      });
    },

    // loading
    ...mapActions(["updateLoading"]),
  },

  computed: {
    ...mapGetters([
      "countryOptions",
      "cityOptions",
      "schoolOptions",
      "majorOptions",
      "languageOptions",
      "resumeTagOptions",
      "freeTagOptions",
      "positionOptions",
    ]),
  },

  created() {
    this.getData();
  },
};
</script>
